import dayjs from 'dayjs';
const Time = (time: Date) => {
  if (!time) {
    return null;
  }
  return dayjs(time).format('HH:mm');
};

export default Time;
